export default __webpack_public_path__ + "static/media/unitymedia-logo_temp.d19c8fb8.png";